exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.progress[data-v-efe9d588] {\n\tposition: fixed;\n\ttop: 0px;\n\tleft: 0px;\n\tright: 0px;\n\theight: 2px;\n\twidth: 0%;\n\t-webkit-transition: width 0.2s, opacity 0.4s;\n\ttransition: width 0.2s, opacity 0.4s;\n\topacity: 1;\n\tbackground-color: #efc14e;\n\tz-index: 999999;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-efe9d588","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Loading.vue
// module id = 1e3L
// module chunks = 1